<template>
    <div style="display: contents">
        <slot />
    </div>
</template>

<script>
export default {
    name: 'ContentsContainer'
}
</script>
